import { fetchGetPaymentMethod } from '@iwoca/lapi-client/v1';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../hooks/useStateKey.hook';

export function useBankDetails() {
  const { stateKey } = useStateKey();

  const { data, refetch } = useQuery({
    queryKey: ['fetchGetPaymentMethod'],
    queryFn: () => fetchGetPaymentMethod({ stateKey: stateKey! }),
  });

  return {
    bankAccountNumber: data?.data?.[0]?.bank_details?.account_number || '',
    sortCode: data?.data?.[0]?.bank_details?.sort_code || '',
    refetchBankDetails: refetch,
  };
}
